import React from 'react';
import HeadComponent from '../../component/HeadComponent';
import ProjectContainer from '../ProjectContainer';
import './index.css';

class ProjectPageContainer extends React.Component {
  render() {
    return (
      <div>
        <HeadComponent />
        <ProjectContainer />
      </div>
    );
  }
}

export default ProjectPageContainer;
